export default {
  GAME: 'game',
  STARRED_GAME: 'starred-game',
  GAME_HOVER: 'game-hover',
  STARRED_GAME_HOVER: 'starred-game-hover',
  ACTIVE_GAME: 'active-game',
  ACTIVE_GAME_HOVER: 'active-game-hover',

  EVENT: 'event',
  STARRED_EVENT: 'starred-event',
  EVENT_HOVER: 'event-hover',
  STARRED_EVENT_HOVER: 'starred-event-hover',
  ACTIVE_EVENT: 'active-event',
  ACTIVE_EVENT_HOVER: 'active-event-hover'
};


// WEBPACK FOOTER //
// ./src/js/util/constants/mapPinTypes.js